const toolTipCustom = (e, id, text, tooltip) => {
  e.cell.innerHTML = `<div class="tooltip-custom" id=${id}>?</div>` + e.cell.innerHTML;
  tooltip.setTooltip(`#${id}`, text);
};

export { toolTipCustom };
